import { useMutation } from "@tanstack/react-query";

import { useStore } from "@/store/index";
import { getCoupons } from "@/store/user/selectors-user";
import { addCoupon } from "../user-queries";

const useAddCoupon = (coupon: string, resetCoupon: () => void) => {
    const dispatchUser = useStore(state => state.dispatchUser);
    const setErrorMsg = useStore(state => state.setErrorMsg);
    const setSuccessMsg = useStore(state => state.setSuccessMsg);
    const dispatchCommon = useStore(state => state.dispatchCommon);

    const coupons = useStore(getCoupons);

    return useMutation({
        mutationFn: addCoupon,
        onSuccess: () => {
            setSuccessMsg("Coupon added successfully");
            dispatchUser({
                type: "UPDATE_USER_DETAIL",
                payload: { coupons: [...coupons, coupon] },
            });
            resetCoupon();
        },
        onSettled: () => {
            dispatchCommon({
                type: "SET_LOADER_PAGE",
                payload: false,
            });
        },
        onError: error => {
            setErrorMsg(error as never);
        },
    });
};

export default useAddCoupon;
